let dashboardsBackendUrl = '';
if (window.location.href.match('trajectory-heatmap-dev-dot')) {
  dashboardsBackendUrl = 'https://dashboards-backend-dev-ootgoxvrsq-uc.a.run.app/';
} else if (window.location.href.match('trajectory-heatmap-dot')) {
  dashboardsBackendUrl = 'https://dashboards-backend-ootgoxvrsq-uc.a.run.app/';
} else {
  dashboardsBackendUrl = 'https://dashboards-backend-dev-ootgoxvrsq-uc.a.run.app/';
}

export const DASHBOARDS_BACKEND_URL = dashboardsBackendUrl;

let trajectoryCruncherUrl = '';
if (window.location.href.match('trajectory-heatmap-dev-dot')) {
  trajectoryCruncherUrl = 'https://trajectory-cruncher-dev-dot-tmc-dashboards.uc.r.appspot.com/';
} else if (window.location.href.match('trajectory-heatmap-dot')) {
  trajectoryCruncherUrl = 'https://trajectory-cruncher-dot-tmc-dashboards.uc.r.appspot.com/';
} else {
  trajectoryCruncherUrl = 'https://trajectory-cruncher-dev-dot-tmc-dashboards.uc.r.appspot.com/';
}

export const TRAJECTORY_CRUNCHER_URL = trajectoryCruncherUrl;
